<template>
  <div class="dropdown-button">
    <button
      role="menuitem"
      aria-haspopup="true"
      aria-controls="app-bar-help-menu"
      :aria-expanded="showHelpDropdown"
      class="app-bar-button"
      :title="__('Help')"
      @click="showHelpDropdown = true"
    >
      <base-icon size="small" name="help_outline" />
    </button>
    <div v-if="showHelpDropdown" class="dropdown-menu">
      <div class="dropdown dropdown-with-curtain" @click.self="cancel">
        <div id="app-bar-help-menu" role="menu" class="dropdown-content">
          <div class="tv tv-list">
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://padlet.blog"
              ><base-icon name="news" /><span>{{ __('News') }}</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://padlet.help/"
              ><base-icon name="book_shelf" /><span>{{ __('Knowledge base') }}</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://www.youtube.com/padlet"
              ><base-icon name="videocam" /><span>{{ __('Video tutorials') }}</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" href="/contact-us"
              ><base-icon name="envelope" /><span>{{ __('Contact us') }}</span></a
            >
            <div v-if="xChat" class="tv-cell tv-cell-default tv-cell-actionable" role="menuitem" @click="showChat">
              <base-icon name="comment" /><span>{{ __('Message us') }}</span>
            </div>
            <a
              v-if="showTwitter"
              role="menuitem"
              class="tv-cell tv-cell-default"
              target="_blank"
              href="https://twitter.com/padlet"
              ><base-icon name="twitter" /><span>{{ __('Tweet at us') }}</span></a
            >
          </div>
          <div class="tv-section-divider" />
          <div class="tv tv-list">
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://padlet.com/about"
              ><base-icon name="info_outline" /><span>{{ __('About') }}</span></a
            >
            <a
              role="menuitem"
              class="tv-cell tv-cell-default"
              target="_blank"
              href="https://padlet.com/about/accessibility"
              ><base-icon name="accessibility" /><span>{{ __('Accessibility') }}</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="https://padlet.com/about/apps"
              ><base-icon name="puzzle" /><span>{{ __('Apps and plugins') }}</span></a
            >
            <a role="menuitem" class="tv-cell tv-cell-default" target="_blank" href="/premium"
              ><base-icon name="rocket" /><span>{{ __('Premium plans') }}</span></a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'
import { showChatWidget } from 'bits/chat_widget'
import { mapState } from 'vuex'

export default {
  components: { BaseIcon },
  mixins: [EscapeToCancelMixin],
  props: ['user'],
  data() {
    return {
      showHelpDropdown: false,
      isChatWidgetLoaded: false,
    }
  },
  computed: {
    ...mapState(['chatWidgetUserToken']),
    showReddit() {
      return this.user.role !== 'student'
    },
    showTwitter() {
      return this.user.role !== 'student'
    },
    xChat() {
      return false // Disable Front Chat until further notice
      //return this.user.role !== 'student' && this.user.paying
    },
  },
  methods: {
    cancel() {
      this.showHelpDropdown = false
    },
    showChat() {
      this.cancel()

      if (!this.isChatWidgetLoaded) {
        this.isChatWidgetLoaded = true
        showChatWidget({ email: this.user.email, userHash: this.chatWidgetUserToken })
      }
    },
  },
}
</script>
